// extracted by mini-css-extract-plugin
export default {"ModalNal":"ModalNal_ModalNal__Z4Q7k","bacgraund":"ModalNal_bacgraund__ShKrX","container":"ModalNal_container__zeiTC"};